module.exports = __webpack_public_path__ + "static/media/PennHeart.cb6c740b.png";